<template>
  <transition name="gl-fade">
    <div v-show="isLoading" class="global-loader" role="progressbar" aria-label="Cargando">
      <div class="global-loader__bar"></div>
    </div>
  </transition>
</template>

<script>
import { isLoading } from '@/plugins/loading';

export default {
  name: 'GlobalLoader',
  setup() {
    return { isLoading };
  },
};
</script>

<style scoped>
.global-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 20000;
  background: rgba(0, 203, 169, 0.15);
  overflow: hidden;
}
.global-loader__bar {
  position: absolute;
  top: 0;
  height: 100%;
  width: 40%;
  border-radius: 0 3px 3px 0;
  background: linear-gradient(90deg, rgba(0, 203, 169, 0.2), #4a95d6 40%, #0f2d5c);
  animation: gl-slide 1.1s cubic-bezier(0.65, 0.05, 0.36, 1) infinite;
}
@keyframes gl-slide {
  0% { left: -42%; width: 42%; }
  50% { width: 55%; }
  100% { left: 100%; width: 42%; }
}
.gl-fade-enter-active,
.gl-fade-leave-active {
  transition: opacity 0.25s ease;
}
.gl-fade-enter-from,
.gl-fade-leave-to {
  opacity: 0;
}
</style>
